import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { TooltipHost, Icon, DefaultButton } from 'office-ui-fabric-react';
import { setPageStep } from '../../../../../features/pageFeatures/createHearingPageSlice';
import { HEARINGSTATUS_CONCLUDED } from '../../../../../constants/api';
import { getAttr } from '../../../../../features/helpers/apiHelpers';
import { push } from 'connected-react-router';
import { MY_HEARINGS_WROTE_URL } from '../../../../../constants/urls';

const goBackIconStyle = {
  fontSize: '12px',
  margin: '10px 0',
  marginRight: '10px',
  color: '#333333',
};

const InvitationButtons = ({ hearingStatus, isUpdatingHearing }) => {
  const { t: translator } = useTranslation();
  const dispatch = useDispatch();

  const status = getAttr(hearingStatus, 'status');
  const isButtonDisabled = status === HEARINGSTATUS_CONCLUDED;

  function onClick() {
    dispatch(push(MY_HEARINGS_WROTE_URL));
  }

  const onClickGoBack = () => dispatch(setPageStep(2));

  return (
    <div>
      <div className="create-hearing-buttons">
        <TooltipHost content={translator('pages.createHearing.releaseWarning')}>
          <DefaultButton
            text={translator(
              'pages.createHearing.createHearingInvitations.invitationButtons.navigateToHearingOverviewButton',
            )}
            onClick={onClick}
            disabled={isUpdatingHearing || isButtonDisabled}
          />
        </TooltipHost>
      </div>

      <button
        className="create-hearing-step-back"
        onClick={onClickGoBack}
        aria-label={translator('global.back')}
      >
        <Icon iconName="Back" className={goBackIconStyle} />
        <p>{translator('global.back')}</p>
      </button>
    </div>
  );
};

export { InvitationButtons };
